import config from ':cloud/config';

export function getRPCEndpointURL(tokenId: string, isTestnet: boolean) {
  if (!tokenId) return 'Loading...';
  return `${config.developerAPIURL}/rpc/v1/${isTestnet ? 'base-sepolia' : 'base'}/${tokenId}`;
}

// TODO: temp solution, we need to drop dependence on the backend for productName
export function getProductName(productName: string) {
  if (productName === 'Base RPC Endpoint') {
    return 'Base Node';
  }
  return productName;
}
